export { default } from './generateUtilityClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/generateUtilityClasses/index.js
// module id = 6
// module chunks = 22